// extracted by mini-css-extract-plugin
export default {"root":"IconChevron_root__PZvPd"};